<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    :fill="colorName"
    :style="`font-size: ${size + 'px'};`"
  >
    <component :is="name.split(' ').join('')" />
  </svg>
</template>

<script>
// Derived from https://vuejs.org/v2/cookbook/editable-svg-icons.html
import Apple from '@/components/icons/Apple'
import AppleFilled from '@/components/icons/AppleFilled'
import ArrowCircleLeft from '@/components/icons/ArrowCircleLeft'
import ArrowCircleRight from '@/components/icons/ArrowCircleRight'
import ArrowDown from '@/components/icons/ArrowDown'
import ArrowLeft from '@/components/icons/ArrowLeft'
import ArrowRight from '@/components/icons/ArrowRight'
import ArrowRight2 from '@/components/icons/ArrowRight2'
import ArrowRight3 from '@/components/icons/ArrowRight3'
import ArrowUpSquare from '@/components/icons/ArrowUpSquare'
import Bag from '@/components/icons/Bag'
import Bell from '@/components/icons/Bell'
import Branch from '@/components/icons/Branch'
import Bread from '@/components/icons/Bread'
import Broccoli from '@/components/icons/Broccoli'
import BroccoliTilted from '@/components/icons/BroccoliTilted'
import Bullseye from '@/components/icons/Bullseye'
import Cake from '@/components/icons/Cake'
import Cart from '@/components/icons/Cart'
import ChatBubbles from '@/components/icons/ChatBubbles'
import CheckboxUnchecked from '@/components/icons/CheckboxUnchecked'
import Checkmark from '@/components/icons/Checkmark'
import Cheese from '@/components/icons/Cheese'
import ChefHat from '@/components/icons/ChefHat'
import ChickenLeg from '@/components/icons/ChickenLeg'
import ChickenWhole from '@/components/icons/ChickenWhole'
import ClickNGo from '@/components/icons/ClickNGo'
import Close from '@/components/icons/Close'
import Cookie from '@/components/icons/Cookie'
import Donut from '@/components/icons/Donut'
import Download from '@/components/icons/Download'
import EcoGear from '@/components/icons/EcoGear'
import Email from '@/components/icons/Email'
import EmailOutline from '@/components/icons/EmailOutline'
import Expand from '@/components/icons/Expand'
import Facebook from '@/components/icons/Facebook'
import Fish from '@/components/icons/Fish'
import FlavorFish from '@/components/icons/FlavorFish'
import FoodTray from '@/components/icons/FoodTray'
import Football from '@/components/icons/Football'
import ForkKnife from '@/components/icons/ForkKnife'
import FreshFlightFish from '@/components/icons/FreshFlightFish'
import GageFast from '@/components/icons/GageFast'
import Grid from '@/components/icons/Grid'
import GrabAndGo from '@/components/icons/GrabAndGo'
import Heart from '@/components/icons/Heart'
import Information from '@/components/icons/Information'
import Instagram from '@/components/icons/Instagram'
import Lasagna from '@/components/icons/Lasagna'
import Leaf from '@/components/icons/Leaf'
import List from '@/components/icons/List'
import Loaf from '@/components/icons/Loaf'
import Location from '@/components/icons/Location'
import Lock from '@/components/icons/Lock'
import MagnifyingGlass from '@/components/icons/MagnifyingGlass'
import Mailbox from '@/components/icons/Mailbox'
import Meat from '@/components/icons/Meat'
import Microwave from '@/components/icons/Microwave'
import Minus from '@/components/icons/Minus'
import Mobile from '@/components/icons/Mobile'
import OpenBook from '@/components/icons/OpenBook'
import PDF from '@/components/icons/PDF'
import Pie from '@/components/icons/Pie'
import Pinterest from '@/components/icons/Pinterest'
import Plate from '@/components/icons/Plate'
import PlayCircle from '@/components/icons/PlayCircle'
import Plus from '@/components/icons/Plus'
import Power from '@/components/icons/Power'
import PriceTag from '@/components/icons/PriceTag'
import PriceTagOutline from '@/components/icons/PriceTagOutline'
import PrimeRib from '@/components/icons/PrimeRib'
import Printer from '@/components/icons/Printer'
import RecycleArrows from '@/components/icons/RecycleArrows'
import Ribs from '@/components/icons/Ribs'
import Rulers from '@/components/icons/Rulers'
import Salad from '@/components/icons/Salad'
import SaladBarSmall from '@/components/icons/SaladBarSmall'
import SaladBarLarge from '@/components/icons/SaladBarLarge'
import Scissors from '@/components/icons/Scissors'
import Skillet from '@/components/icons/Skillet'
import Store from '@/components/icons/Store'
import Search from '@/components/icons/Search'
import ShoppingBag from '@/components/icons/ShoppingBag'
import Snowflake from '@/components/icons/Snowflake'
import Stack from '@/components/icons/Stack'
import Star from '@/components/icons/Star'
import Stars from '@/components/icons/Stars'
import StarFilled from '@/components/icons/StarFilled'
import Steak from '@/components/icons/Steak'
import Sun from '@/components/icons/Sun'
import Sun2 from '@/components/icons/Sun2'
import Sushi from '@/components/icons/Sushi'
import SushiRoll from '@/components/icons/SushiRoll'
import SustainableSeafood from '@/components/icons/SustainableSeafood'
import Touch from '@/components/icons/Touch'
import Truck from '@/components/icons/Truck'
import Twitter from '@/components/icons/Twitter'
import Umbrella from '@/components/icons/Umbrella'
import User from '@/components/icons/User'
import WaterBowl from '@/components/icons/WaterBowl'
import Watermelon from '@/components/icons/Watermelon'
import Wallet from '@/components/icons/Wallet'
import Wine from '@/components/icons/Wine'
import YouTube from '@/components/icons/YouTube'

export default {
  props: {
    name: {
      type: String,
      default: 'box'
    },
    size: {
      type: [Number, String],
      default: 'inherit'
    },
    color: {
      type: String
    }
  },
  computed: {
    colorName () {
      switch (this.color) {
        case 'green':
          return '#3a823d'
        case 'blue':
          return '#228096'
        case 'orange':
          return '#dd5317'
        case 'red':
          return '#c50909'
        case 'black':
          return '#000'
        case 'white':
          return '#fff'
        case '':
          return '#3a823d'
        case null:
          return '#3a823d'
        case undefined:
          return '#3a823d'
        default:
          return this.color
      }
    }
  },
  components: {
    Apple,
    AppleFilled,
    ArrowCircleLeft,
    ArrowCircleRight,
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    ArrowRight2,
    ArrowRight3,
    ArrowUpSquare,
    Bag,
    Bell,
    Branch,
    Bread,
    Broccoli,
    BroccoliTilted,
    Bullseye,
    Cake,
    Cart,
    ChatBubbles,
    CheckboxUnchecked,
    Checkmark,
    Cheese,
    ChefHat,
    ChickenLeg,
    ChickenWhole,
    Close,
    ClickNGo,
    Cookie,
    Donut,
    Download,
    EcoGear,
    Email,
    EmailOutline,
    Expand,
    Facebook,
    Fish,
    FlavorFish,
    FoodTray,
    Football,
    ForkKnife,
    FreshFlightFish,
    Instagram,
    GageFast,
    GrabAndGo,
    Grid,
    Heart,
    Information,
    Lasagna,
    Leaf,
    List,
    Loaf,
    Location,
    Lock,
    MagnifyingGlass,
    Mailbox,
    Meat,
    Microwave,
    Minus,
    Mobile,
    OpenBook,
    PDF,
    Pie,
    Pinterest,
    Plate,
    PlayCircle,
    Plus,
    Power,
    PriceTag,
    PriceTagOutline,
    PrimeRib,
    Printer,
    RecycleArrows,
    Ribs,
    Rulers,
    Salad,
    SaladBarSmall,
    SaladBarLarge,
    Scissors,
    Skillet,
    Store,
    Search,
    ShoppingBag,
    Snowflake,
    Stack,
    Star,
    Stars,
    StarFilled,
    Steak,
    Sun,
    Sun2,
    Sushi,
    SushiRoll,
    SustainableSeafood,
    Touch,
    Truck,
    Twitter,
    Umbrella,
    User,
    WaterBowl,
    Watermelon,
    Wallet,
    Wine,
    YouTube
  }
}
</script>

<style scoped lang="scss">
  svg {
    height: 1em;
    position: relative;
    top: .125em;
    transition: fill .3s;
    width: 1em;

    &.svg-text-center {
      vertical-align: bottom;
    }

    &.icon--left {
      margin-right: 1rem !important;
    }
  }

  .font-color-blue {
    svg {
      fill: $blue;
    }
  }
</style>
